export const cleanName = (name) => {
    let nameClean = name;
    if (nameClean) {
      nameClean = nameClean.split(" ");
      nameClean = nameClean.filter(i=>isNaN(i));
      nameClean = nameClean.join(' ');
    }
    return nameClean
  }